<template>
  <div>
    <div class="container">
      <div class="py-md-5 text-center">
        <div class="py-5">
          <p class="pb-4">
            <router-link :to="{ name: 'home' }">
              <img class="" src="/static/images/logo.svg" width="120">
            </router-link>
          </p>
          <h1 class="title h1-lg">Where digital<br class="d-md-none"> <span class="text-primary">comes to life</span></h1>
          <p>
            We create beautiful digital products
          </p>
          <p class="mb-md-0">
            <router-link class="btn btn-primary my-2" :to="{ name: 'request-proposal' }">Start a New Project</router-link>
            <router-link class="btn btn-outline-primary my-2" :to="{ name: 'about' }">Who We Are</router-link>
          </p>
        </div>
        <hr class="space space-xs">
      </div>

      <div class="row" v-if="clients && clients.length > 0">
        <div class="col">
          <p class="text-center mt-5 text-muted">Trusted by the best teams</p>
          <div class="row clients">
            <div class="col-3 col-md mb-4 text-center pr-1" v-for="(client, index) in clients" :key="index">
              <img class="img-fluid" :src="client.logo" :alt="client.name">
            </div>
          </div>
          <hr class="space space-sm d-block d-sm-none">
          <hr class="space d-none d-sm-block">
        </div>
      </div>
      
      <h1 class="title h1-lg text-center py-4">Recent work</h1>
      <hr class="space space-sm">
    
      <div v-if="projects && projects.length > 0">
        <div v-for="project in projects" :key="project.id">
          <div class="row align-items-center cursor-pointer" @click.prevent="openProject(project.id)">
            <div class="col-md-8" v-if="project.picture">
              <img class="img-fluid img-card mb-3" :src="project.picture" alt="">
            </div>
            <div class="col-md-4 pr-md-5">
              <h2>{{ project.name }}</h2>
              <div v-html="project.tagline" class="lh15"></div>
              <p class="py-4">
                <a href="#" @click.prevent="openProject(project.id)" class="btn btn-sm btn-outline-primary">Learn more</a>
              </p>
            </div>
          </div>
          <hr class="space d-none d-md-block">
          <hr class="space space-sm">
        </div>
      </div>

      <hr class="space space-sm">

      <div class="row">
        <div class="col col-md-8 offset-md-2 text-center">
          <h1 class="title h1-lg text-center py-4">From <span class="text-primary medium">ideas</span> to prototypes to scale-ups</h1>
          <hr class="space space-xs">
          <p>
            We are thinkers, creatives, <span class="text-primary medium">designers</span> and <span class="text-primary medium">hackers</span>.
            We wear many hats, we learn new things and we focus on the task at hand.
          </p>
          <hr class="space space-xs">
          <router-link class="btn btn-primary" :to="{ name: 'request-proposal' }">Get in touch</router-link>
          <router-link class="btn btn-outline-primary" :to="{ name: 'about' }">About us</router-link>
          <hr class="space d-sm-none d-block">
          <hr class="space d-none d-sm-block space-lg">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import slugify from 'slugify'

export default {
  name: 'home',
  props: ['referralKey'],
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      projects: state => state.projects.homeProjects,
      clients: state => state.clients.homeClients
    })
  },
  mounted () {
    window.scrollTo(0, 0)
    if (this.referralKey) {
      this.$store.commit('SET_REFERRAL_KEY', this.referralKey)
      this.$router.push({ name: 'home' })
    }
  },
  created () {
    this.$store.dispatch('LOAD_HOME_PROJECTS')
    this.$store.dispatch('LOAD_HOME_CLIENTS')
  },
  methods: {
    openProject (id) {
      let project = this.projects.find((e) => e.id === id)
      if (project) {
        window.open(this.getProjectUrl(project))
      }
    },
    getProjectUrl (project) {
      if (project.case_study_url) {
        return project.case_study_url
      } else {
        return '/portfolio/' + project.id + '/' + slugify(project.name)
      }
    }
  }
}
</script>
